// extracted by mini-css-extract-plugin
export default {"closeButton":"PopUpPublishDraft_closeButton__jwa1t","rounded":"PopUpPublishDraft_rounded__dnB4B"};